import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../environments/environment';

// Need to Create a static class so we can mock this in angularjs unit test
// this is a temporary until we able to mock httpClient in the angularjs
export class DashboardTranslateLoader {
	public static factory (http: HttpClient): TranslateLoader {
		return DashboardTranslateLoader.makeLoader(http);
	}

	public static makeLoader (http: HttpClient): TranslateLoader {
		return new TranslateHttpLoader(http, `${environment.translationsPrefix}translations/translation/`);
	}
}
